import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Directive } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';


import { AppComponent } from './app.component';
import { PlayerComponent } from './editor/player/player.component';
import { TextItemComponent } from './editor/text-item/text-item.component';
import { EditorComponent } from './editor/editor.component';
import { LeftMenuComponent } from './core/navigation/left-menu/left-menu.component';
import { TopNavigationComponent } from './core/navigation/top-navigation/top-navigation.component';
import { PageBreadcrumbsComponent } from './core/navigation/page-breadcrumbs/page-breadcrumbs.component';
import { LeftMenuEditorComponent } from './editor/left-menu-editor/left-menu-editor.component';
import { MainPageComponent } from './core/pages/main-page/main-page.component';
import { FileUploadComponent } from './core/file-upload/file-upload.component';
import { UploaderComponent } from './uploader/uploader.component';
import { FooterComponent } from './core/navigation/footer/footer.component';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap';

import { ModalComponent } from './core/modals/modal/modal.component';
import { ViewerComponent } from './viewer/viewer.component';
import { SearchStringComponent } from './core/navigation/search-string/search-string.component';
import { InstructionComponent } from './core/pages/instruction/instruction.component';
import { TranslationComponent } from './core/translation/translation.component';
import { RemovePodcastComponent } from './core/modals/remove-podcast/remove-podcast.component';



const appRoutes: Routes = [
    { path: '', redirectTo: 'main', pathMatch: 'full' },
    { path: 'main', component: MainPageComponent },
    { path: 'main/:mode', component: MainPageComponent },
    { path: 'instruction', component: InstructionComponent },
    { path: 'editor/uploader', component: UploaderComponent },
    { path: 'editor/uploader/:id', component: UploaderComponent },
    { path: 'editor/edit/:id', component: EditorComponent },
    { path: 'view/:id', component: ViewerComponent },
    { path: 'view/:id/:secret', component: ViewerComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    PlayerComponent,
    TextItemComponent,
    EditorComponent,
    LeftMenuComponent,
    TopNavigationComponent,
    PageBreadcrumbsComponent,
    LeftMenuEditorComponent,
    MainPageComponent,
    FileUploadComponent,
    UploaderComponent,
    FooterComponent,
    ModalComponent,
    ViewerComponent,
    SearchStringComponent,
    InstructionComponent,
    TranslationComponent,
    RemovePodcastComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(
        appRoutes
//        { enableTracing: true } // <-- debugging purposes only
    ),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
      ModalComponent,
      RemovePodcastComponent
  ]
})
export class AppModule { }